import { DRAWER_KEY } from './drawer'
import { MODAL_KEYS } from './modal'
import { MY_BILLS_PAGE_TAB_LABEL } from './myBills'
import { ROUTES } from './routes'

export const REDIRECT_QUERY = {
  MODEM: 'redirectWifi',
  NEGOTIATION: 'redirectNegociacao',
  SERVICE_ORDERS: 'redirectOrdensServico',
  UNLOCK_ACCOUNT: 'redirectDesbloqueioConfianca',
  VIRTUAL_SUPPORT: 'redirectSuporteVirtual',
  MY_BILLS: 'redirectHistoricoFaturas',
  MY_PLAN: 'redirectMeuPlano',
  PROTOCOL_LIST: 'redirectHistoricoAtendimento',
  DUE_DATE: 'redirectAlterarVencimentoFatura',
  DOCUMENTS: 'redirectTrocaTitularidade',
  ADDRESS_CHANGE: 'redirectAlterarEndereco',
  FILE_UPLOAD: 'redirectEnvioDocumento',
  REFER_FRIEND: 'redirectIndiqueAmigo',
  STORE: 'redirectLoja',
}

export const REDIRECT_MOBILE_KEYS = {
  BILL_HISTORY: 'historico-faturas',
  CHANGE_ADDRESS: 'alterar-endereco',
  CHANGE_DUE_DATE: 'alterar-vencimento-fatura',
  MY_PLAN: 'meu-plano',
  REFER_FRIEND: 'indique-amigo',
  SEND_DOCUMENT: 'envio-documento',
  SERVICE_HISTORY: 'historico-atendimento',
  SERVICE_ORDERS: 'oss',
  STORE: 'loja',
  SUPPORT: 'suporte',
  TRANSFER_OWNERSHIP: 'troca-titularidade',
  NEGOTIATION: 'negociacao',
  WIFI: 'wifi',
  UNLOCK_ACCOUNT: 'desbloqueio-conta',
}

export const DEEP_LINKS_APP_TO_WEB = {
  [REDIRECT_MOBILE_KEYS.BILL_HISTORY]: REDIRECT_QUERY.MY_BILLS,
  [REDIRECT_MOBILE_KEYS.CHANGE_ADDRESS]: REDIRECT_QUERY.ADDRESS_CHANGE,
  [REDIRECT_MOBILE_KEYS.CHANGE_DUE_DATE]: REDIRECT_QUERY.DUE_DATE,
  [REDIRECT_MOBILE_KEYS.MY_PLAN]: REDIRECT_QUERY.MY_PLAN,
  [REDIRECT_MOBILE_KEYS.REFER_FRIEND]: REDIRECT_QUERY.REFER_FRIEND,
  [REDIRECT_MOBILE_KEYS.SEND_DOCUMENT]: REDIRECT_QUERY.FILE_UPLOAD,
  [REDIRECT_MOBILE_KEYS.SERVICE_HISTORY]: REDIRECT_QUERY.PROTOCOL_LIST,
  [REDIRECT_MOBILE_KEYS.SERVICE_ORDERS]: REDIRECT_QUERY.SERVICE_ORDERS,
  [REDIRECT_MOBILE_KEYS.STORE]: REDIRECT_QUERY.STORE,
  [REDIRECT_MOBILE_KEYS.SUPPORT]: REDIRECT_QUERY.VIRTUAL_SUPPORT,
  [REDIRECT_MOBILE_KEYS.TRANSFER_OWNERSHIP]: REDIRECT_QUERY.DOCUMENTS,
  [REDIRECT_MOBILE_KEYS.WIFI]: REDIRECT_QUERY.MODEM,
  [REDIRECT_MOBILE_KEYS.NEGOTIATION]: REDIRECT_QUERY.NEGOTIATION,
  [REDIRECT_MOBILE_KEYS.UNLOCK_ACCOUNT]: REDIRECT_QUERY.UNLOCK_ACCOUNT,
}

export const CTA_KEYS = {
  REFER_FRIEND: 'AccountReferral',
  DETAIL_STORE: 'DetailStoreScreen',
  MY_BILLS: 'FaturaScreen',
  MY_PLAN: 'MyPlanScreen',
  STORE: 'StoreScreen',
  FIDELITY: 'SpecialOfferScreen',
}

const MY_BILLS_ROUTE = `${ROUTES.INVOICES.PATH}#${MY_BILLS_PAGE_TAB_LABEL.BANKSLIPS}`

export const DEEP_LINKS = [
  { query: REDIRECT_QUERY.MODEM, drawerKey: DRAWER_KEY.MODEM },
  { query: REDIRECT_QUERY.NEGOTIATION, drawerKey: DRAWER_KEY.NEGOTIATION },
  { query: REDIRECT_QUERY.SERVICE_ORDERS, drawerKey: DRAWER_KEY.SERVICE_ORDERS },
  { query: REDIRECT_QUERY.UNLOCK_ACCOUNT, drawerKey: DRAWER_KEY.UNLOCK_ACCOUNT },
  { query: REDIRECT_QUERY.VIRTUAL_SUPPORT, drawerKey: DRAWER_KEY.VIRTUAL_SUPPORT },
  {
    query: REDIRECT_QUERY.MY_BILLS,
    pageKey: MY_BILLS_ROUTE,
  },
  { query: REDIRECT_QUERY.MY_PLAN, drawerKey: DRAWER_KEY.PLAN },
  { query: REDIRECT_QUERY.PROTOCOL_LIST, drawerKey: DRAWER_KEY.PROTOCOL },
  { query: REDIRECT_QUERY.DUE_DATE, drawerKey: DRAWER_KEY.DUE_DATE },
  {
    query: REDIRECT_QUERY.DOCUMENTS,
    pageKey: ROUTES.DOCUMENTS.PATH,
  },
  { query: REDIRECT_QUERY.ADDRESS_CHANGE, drawerKey: DRAWER_KEY.ADDRESS_CHANGE },
  { query: REDIRECT_QUERY.FILE_UPLOAD, modalKey: MODAL_KEYS.FILE_UPLOAD },
  { query: REDIRECT_QUERY.REFER_FRIEND, modalKey: MODAL_KEYS.REFER_FRIEND },
  { query: REDIRECT_QUERY.STORE, drawerKey: DRAWER_KEY.STORE },
]

export const INTERNAL_REDIRECT_TYPE = {
  MODAL: 'MODAL',
  DRAWER: 'DRAWER',
  ROUTE: 'ROUTE',
}

export const INTERNAL_REDIRECT_KEYS = [
  {
    KEY: CTA_KEYS.REFER_FRIEND,
    TYPE: INTERNAL_REDIRECT_TYPE.MODAL,
    TO: MODAL_KEYS.REFER_FRIEND,
  },
  {
    KEY: CTA_KEYS.DETAIL_STORE,
    TYPE: INTERNAL_REDIRECT_TYPE.DRAWER,
    TO: DRAWER_KEY.STORE,
  },
  {
    KEY: CTA_KEYS.MY_BILLS,
    TYPE: INTERNAL_REDIRECT_TYPE.ROUTE,
    TO: MY_BILLS_ROUTE,
  },
  {
    KEY: CTA_KEYS.MY_PLAN,
    TYPE: INTERNAL_REDIRECT_TYPE.DRAWER,
    TO: DRAWER_KEY.PLAN,
  },
  {
    KEY: CTA_KEYS.STORE,
    TYPE: INTERNAL_REDIRECT_TYPE.DRAWER,
    TO: DRAWER_KEY.STORE,
  },
  {
    KEY: CTA_KEYS.FIDELITY,
    TYPE: INTERNAL_REDIRECT_TYPE.DRAWER,
    TO: DRAWER_KEY.FIDELITY,
  },
]
